import minimatch from 'minimatch';
import lodash from 'lodash';
import { PUBLIC, AUTHED } from '@pro/common/config/page-permission';

/** @typedef {import('../declarations/page-permission').PagePermission} PagePermission */
/** @typedef {import('../declarations/page-permission').PagePermissions} PagePermissions */

/**
 * 获取指定路由的权限配置
 * @param {string} path 路径
 * @param {PagePermissions} options 指定从哪一个权限配置列表中匹配，默认为所有权限列表
 * @return {PagePermission=}
 */
const getPagePermission = (path, options = [...PUBLIC, ...AUTHED]) =>
  options.find((item) => {
    const matcher = item.path;
    if (typeof matcher === 'string') {
      return minimatch(path, matcher);
    }
    if (typeof matcher === 'function') {
      return matcher(path);
    }
    if (lodash.isRegExp(matcher)) {
      return matcher.test(path);
    }
    return false;
  });

export default getPagePermission;
